import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { patientExtractData } from '../mockData/patient-extract-data';

const PatientExtractApi = [
  rest.get(`${API_ROOT}patient-extract/patient_id1`, (req, res, ctx) => res(ctx.json(patientExtractData))),
  rest.get(`${API_ROOT}patient-extract/patient_id2`, (req, res, ctx) => res(ctx.json(patientExtractData))),
  rest.get(`${API_ROOT}patient-extract/200`, (req, res, ctx) => res(ctx.json(patientExtractData))),
];

export default PatientExtractApi;
